var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('icon',{attrs:{"name":_vm.name,"size":"lg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }